import React from 'react'
import {compare, formatTimeString} from './BusinessScheduleTimeHelper'
import {RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {Nullable} from '../../../../app/TypeHelpers'
import {TimeTableTime} from './BusinessScheduleItemInterfaces'
import equal from 'fast-deep-equal'
import {HOURS, HOURS_24} from '../../../../CodeMaster'
import { Box } from '@mui/material';

export interface TimeZoneSetting {
    reservationTimeMax: number
    startTime: TimeTableTime<HOURS_24>
    endTime: TimeTableTime<HOURS_24 | HOURS>
}

export interface ReservationTimeSettingMaxReservationTimeProps {
    allDayReservationTimeMax: Nullable<number>
    timeZoneSettings: Nullable<TimeZoneSetting[]>
}

const ReservationTimeSettingMaxReservationTime:
    React.FC<ReservationTimeSettingMaxReservationTimeProps> = React.memo(props => {

    if (props.allDayReservationTimeMax) {
        return <div>終日{props.allDayReservationTimeMax}時間まで</div>
    }

    if (props.timeZoneSettings && props.timeZoneSettings.length > 0) {

        const renderTimezones = () => {
            if (!props.timeZoneSettings) {
                return null
            }
            return <div> {
                props.timeZoneSettings.map((setting, index) => {
                    const isNextDay: boolean = (compare(setting.startTime, setting.endTime) > 0)
                    const nextDayString: string = (isNextDay) ? '翌' : ''
                    const startText = formatTimeString(setting.startTime)
                    const endText = formatTimeString(setting.endTime)
                    return <div key={index}>{`${startText}〜${nextDayString}${endText}`}</div>
                })
            }</div>
        }

        const renderMaxTimes = () => {
            if (!props.timeZoneSettings) {
                return null
            }
            return <div> {
                props.timeZoneSettings.map((setting, index) => {
                    const maxText = `${setting.reservationTimeMax}時間`
                    return <div key={index}>{`最大${maxText}まで`}</div>
                })
            }</div>
        }
        return <> {
            <RowFlexContainer>
                {renderTimezones()}
                <Box ml={'8px'}/>
                {renderMaxTimes()}
            </RowFlexContainer>
        }</>
    }
    return <div>設定がありません</div>
}, (prevProps, nextProps) => (prevProps === nextProps || equal(prevProps, nextProps)))

ReservationTimeSettingMaxReservationTime.displayName = 'ReservationTimeSettingMaxReservationTime'
export default ReservationTimeSettingMaxReservationTime
